import React from 'react';

const PatientImage = () => (
  <div className="patient-image">
    <img src="/images/takeda_co-pay_subpage_image.png" alt="Confident older woman with natural gray hair in navy blouse looking upward outdoors, framed by modern abstract design elements. Models are used for illustrative purposes only." />
    <p>Models are used for illustrative purposes only.</p>
  </div>
);

export default PatientImage;
